"use client";

import { cn } from "@/lib/utils";
import { ChevronDownIcon } from "@/components/icons/ChevronDownIcon";

/**
 * The list's one fold control: a full-width quiet row, centered mono label, and
 * a chevron that rotates when it opens.
 *
 * Each fold names what it closes rather than saying "less" — a page can have
 * more than one open at a time, and identical labels are indistinguishable to
 * anyone hearing the page rather than seeing it.
 */
export function GhostRow({
  open,
  label,
  openLabel,
  onClick,
  className,
}: {
  open: boolean;
  label: string;
  openLabel: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      className={cn(
        "flex items-center justify-center gap-2 w-[calc(100%_+_22px)] mt-1.5 -mr-3 mb-0 -ml-2.5 p-2.5 bg-none border-none rounded-10 font-mono text-3 tracking-[0.06em] text-fg-subtle cursor-pointer transition-colors hover:bg-bg-subtle hover:text-fg-default [&_svg]:w-3 [&_svg]:h-3 [&_svg]:transition-transform duration-200",
        open && "[&_svg]:transform-[rotate(180deg)]",
        className
      )}
      onClick={onClick}
    >
      <span>{open ? openLabel : label}</span>
      <ChevronDownIcon />
    </button>
  );
}
